import {API,instance} from "../const/api";

export async function auth(param){


    const { status, data: results  } = await instance.post(API.Auth,
        {
            "email":param.email,
            "password":param.password,
        },{
            headers: {
                'Content-Type': 'application/json',
            }
        }
    );
    let error = false;
    if(status === 200){

        return { status, results,error }
    }else{
        error = true;
        return { status, results,error }
    }


}
